import {LayoutRect} from "@/core/types";
import {defineStore} from "pinia";
import {computed, Ref, ref, toValue, watch} from "vue";
import {Screen} from 'quasar';

const STORE_NAME = 'layout'

export const useLayoutStore = defineStore(STORE_NAME, () => {

    const initialHeaderHeight = 62

    const drawerMainModel = ref<boolean>(false)
    const drawerBasket = ref<boolean>(true)
    const drawerBasketMobile = ref<boolean>(false)

    const headerHeight = ref<number>(initialHeaderHeight)
    const headerHeightCollapsed = ref<number>(initialHeaderHeight) // Высота свернутой шапки
    const headerTopHeight = ref<number>(initialHeaderHeight)
    const headerHeightCss = computed(() => headerHeight.value + 'px')

    const sideColumnTopOffset = ref<number>(initialHeaderHeight)
    const sideColumnTopOffsetCss = computed(() => sideColumnTopOffset.value + 'px')

    // Синхронизация sideColumnTopOffset с headerHeight для десктопа
    watch(headerHeight, (newHeight) => {
        sideColumnTopOffset.value = newHeight
    })

    const contentColumn = ref<LayoutRect>({
        width: 0,
        height: 0,
        left: 0,
        top: 0,
    })

    const setHeaderHeight = (height: number) => {
        headerHeight.value = height
        // debugger;
    }

    const onMainColumnResize = (info: {
        width: number,
        height: number
    }, mainColRef: Ref<HTMLElement | null | undefined> | HTMLElement | null | undefined) => {
        const mainCol = toValue(mainColRef)
        const newRect = {} as LayoutRect
        newRect.width = info.width
        newRect.height = info.height
        if (mainCol) {
            const rect = mainCol.getBoundingClientRect();
            newRect.left = rect.left
            newRect.top = rect.top
            newRect.right = Screen.width - info.width - rect.left
        }
        contentColumn.value = newRect
    }

    return {
        headerTopHeight,
        headerHeight,
        setHeaderHeight,
        headerHeightCollapsed,
        headerHeightCss,
        drawerMainModel,
        drawerBasket,
        drawerBasketMobile,
        sideColumnTopOffset,
        sideColumnTopOffsetCss,
        contentColumn,
        onMainColumnResize
    }
})

